import React from "react";
import { AspectRatio, Box } from "@chakra-ui/react";
import Balancer from "react-wrap-balancer";
import { FillImage } from "components/images";
import { BookDemoButton } from "components/event-tracking";
import { HeroSpotlightBackgroundEffects } from "components/hero";
import { Section } from "components/section";
import { FadeIn } from "ui/animations";
import { TextTitle } from "ui/text";
import heroImage from "../../../../public/assets/platform/real-time-personalization/hero.png";

type Props = {
  eyebrow?: string;
  title: string;
  description: string;
};

export function RealTimeHero({ eyebrow, title, description }: Props) {
  return (
    <Box as="section" pos="relative" overflow="hidden" bg="new.green.150">
      <HeroSpotlightBackgroundEffects theme="light" bgColor="new.green.150" spotlightColor="white" />

      <Box pos="relative">
        <FadeIn duration={0.3}>
          <Section as="div" themeBgColor="new.green.150" my="0" pt="biggest">
            <TextTitle
              size="xl"
              align="center"
              chip={eyebrow ? { text: eyebrow } : undefined}
              titleAs="h1"
              title={<Balancer>{title}</Balancer>}
              description={description}
              descriptionAs="h2"
              maxW="900px"
              descriptionMaxW="800px"
              actions={<BookDemoButton />}
            />
          </Section>

          <Section as="div" themeBgColor="white" my="0" py="biggest">
            <AspectRatio
              ratio={1204 / 522}
              pos="relative"
              w="100%"
              border="1px"
              borderColor="new.gray.150"
              borderRadius={{ base: "small", md: "bigger" }}
              overflow="hidden"
            >
              <FillImage
                src={heroImage}
                alt="Illustration showing real-time personalization data flow from a mobile app, through Hightouch, to personalized user experiences. The mobile phone displays a shopping app with a product image of winter jackets and buttons to 'add to cart', 'add to wishlist', or 'keep browsing'. Data flows from the app to Hightouch, labeled 'customer 360 data with real-time signals'. The data then flows out to deliver personalized user experiences such as triggered messages, real-time offers, product recommendations, and same-session personalization."
              />
            </AspectRatio>
          </Section>
        </FadeIn>
      </Box>
    </Box>
  );
}
